module.exports = __webpack_public_path__ + "static/img/login_part01_img03.03b76d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_part01_img03.png
// module id = uZwa
// module chunks = 1